module.exports = __webpack_public_path__ + "img/Group 26.e87b6ab3.png";